import { cx } from "../../lib/index.js";
export function createAutocompleteSuggestionComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompleteSuggestion(_ref2) {
    var item = _ref2.item,
      onSelect = _ref2.onSelect,
      _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames;
    return createElement("div", {
      onClick: onSelect,
      className: cx('ais-AutocompleteSuggestion', classNames.root)
    }, item.query);
  };
}